export default __webpack_public_path__ + "images/ENT.b17224c.png";